/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import { JSONable } from '@irian-ro/abstract-resource';
import { NetopiaCardPaymentInitiationRequest, SubscriptionTypeVoModel } from '@well/domain';

export class PaymentMethodMetaModel extends JSONable {
  paymentMethodTypes: string[] | null = null;
  subscriptionTypeVO: SubscriptionTypeVoModel | null = null;
  validationRedirectUrl: string | null = null;
  cardPaymentInitiationRequest: NetopiaCardPaymentInitiationRequest | null = null;

}
